import avatarLogo from '../assets/navbar-icons/avatarlogo2.webp';
// import avatarTwoLogo from '../assets/navbar-icons/avatarlogo2.jpeg';

// Individual Project Assets
import atlantaTasteTrekLogo from '../assets/project-assets/atlanta-taste-trek/atlanta_taste_trek_orange.png';
import focusFarmerLogo from '../assets/project-assets/focus-farmer/focus_farmer_splash_title.png';
import beanILogo from '../assets/project-assets/beani/beani_logo.svg';
import moneyMentorLogo from '../assets/project-assets/money-mentor/Money_mentor_Logo.png';
import playPeekCover from '../assets/project-assets/playpeek/HDIconwithbackground.png';
import playPeekMiniPlayer from '../assets/project-assets/playpeek/PlayPeek-MiniPlayer_v0.4.png';
import playPeekMiniPlayerPaused from '../assets/project-assets/playpeek/PlayPeek-MiniPlayer_Paused_v0.4.png';
import playPeekAppearance from '../assets/project-assets/playpeek/PlayPeek-Appearance_v0.4.png';
import playPeekHistory from '../assets/project-assets/playpeek/PlayPeek-History_v0.4.png';
import playPeekGeneralEnglish from '../assets/project-assets/playpeek/PlayPeek-GeneralEN_v0.4.png';
import playPeekGeneralSpanish from '../assets/project-assets/playpeek/PlayPeek-GeneralES_v0.4.png';
// Local Test Image
import capybaraIllustration from '../images/cute-cartoon-capybara-cap-sunglasses-600nw-2575177821.jpg.webp';
// Social Media Assets
import facebookPositive from '../assets/social-assets/facebook_positive.svg';
import facebookNegative from '../assets/social-assets/facebook_negative.svg';
import githubPositive from '../assets/social-assets/github_positive.svg';
import githubNegative from '../assets/social-assets/github_negative.svg';
import linkedInPositive from '../assets/social-assets/linkedin_positive.svg';
import linkedInNegative from '../assets/social-assets/linkedin_negative.svg';
import instagramPositive from '../assets/social-assets/instagram_positive.svg';
import instagramNegative from '../assets/social-assets/instagram_negative.svg';
import youtubePositive from '../assets/social-assets/youtube_positive.svg';
import youtubeNegative from '../assets/social-assets/youtube_negative.svg';
import googlePositive from '../assets/social-assets/google_positive.svg';
import googleNegative from '../assets/social-assets/google_negative.svg';
import twitterPositive from '../assets/social-assets/twitter_positive.svg';
import twitterNegative from '../assets/social-assets/twitter_negative.svg';
// Under Construction Assets
import catWorkVideo from '../assets/temp/underconstruction.mp4';

export const siteAssets = {
  avatarLogo,
  // Local Test Image
  capybaraIllustration,
  atlantaTasteTrekLogo,
  focusFarmerLogo,
  beanILogo,
  moneyMentorLogo,
  playPeekCover,
  playPeekMiniPlayer,
  playPeekMiniPlayerPaused,
  playPeekAppearance,
  playPeekHistory,
  playPeekGeneralEnglish,
  playPeekGeneralSpanish,
  // Social Media Positive Assets
  facebookPositive,
  githubPositive,
  linkedInPositive,
  instagramPositive,
  youtubePositive,
  googlePositive,
  twitterPositive,
  // Social Media Negative Assets
  facebookNegative,
  githubNegative,
  linkedInNegative,
  instagramNegative,
  youtubeNegative,
  googleNegative,
  twitterNegative,
  // Under Construction Assets
  catWorkVideo,
};
